import { useSelector } from "react-redux";
import { useMemo } from "react";
import { Button } from "@deere/fuel-react";
import RefreshIcon from '@mui/icons-material/Refresh';
import FilterHeader from "../../../components/FilterHeader";

const LoadBuildPageHeader = ({ 
  isInternal, 
  setProvider, 
  supplierName, 
  lastUpdateTime, 
  getTableData,
  // Filter props
  isFiltered,
  filterTitle,
  totalFilteredOrders,
  onClearFilter,
  filterSource
}) => {

  const onProviderChange = (providerValue) => {
    setProvider(providerValue);
  };

  const providerList = useSelector((storeState) => storeState.getProviderList);
  // Get the selected provider from Redux state
  const selectedProvider = useSelector((storeState) => storeState.setProvider);

  const pl = useMemo(
    () =>
      providerList.sort(function (a, b) {
        return a.descr.localeCompare(b.descr, "en", { sensitivity: "base" });
      }),
    [providerList]
  );

  return (
    <div className="flex flex-nowrap w-full pl-2 mr-0 justify-between">
      {isInternal ? (
        <div className="p-1 w-1/4 flex items-center">
          <h6>
            <select
              class="cstm-select focus:outline-none focus:shadow-green-700 focus:shadow-md  text-[0.8rem] block"
              id="inputGroupSelect01"
              value={selectedProvider || ""}
              onChange={(evt) => onProviderChange(evt.target.value)}
            >
              <option value="" id="">
                Select Forwarder
              </option>
              {pl.map((providerOption) => (
                <option
                  value={providerOption.sapSuplrNo}
                  id={providerOption.providerId}
                  key={providerOption.providerId}
                >
                  {providerOption.descr}
                </option>
              ))}
            </select>
          </h6>
        </div>
      ) : (
        <h6 className="p-1 w-1/4 font-bold text-xs  pl-2 flex items-center">
          {supplierName}
        </h6>
      )}

      {/* Filter Header positioned between select forwarder and LOAD BUILD title */}
      <div className="flex items-center pt-3">
        <FilterHeader
          isFiltered={isFiltered}
          filterTitle={filterTitle}
          totalFilteredOrders={totalFilteredOrders}
          onClearFilter={onClearFilter}
          filterSource={filterSource}
        />
      </div>

      <div className="w-1/4 flex items-center justify-center">
        <b id="load-build-title" className="text-xs">LOAD BUILD</b>
      </div>
      
      {/* Last Update positioned between LOAD BUILD title and refresh button */}
      <div class="w-1/4  text-left flex items-center">
        <p className="text-xs">Last Update: {lastUpdateTime}</p>
      </div>
      
      <div className="flex items-center">
        <Button
          variant="pr1imary"
          size="small"
          onClick={getTableData}
          title="Refresh Data"
        >
          <RefreshIcon style={{ fontSize: '20px' }} />
        </Button>
      </div>
    </div>
  );
};

export default LoadBuildPageHeader;
